import { HttpOptions, RegisteredHttpEndpoint } from '@luminovo/http-client';
import { QueryKey } from '@tanstack/react-query';

export function httpQueryKey<T extends RegisteredHttpEndpoint>(endpoint: T, options?: HttpOptions<T>): QueryKey {
    if (!options) {
        return [endpoint];
    }
    return [endpoint, options];
}
